import Box from "@mui/material/Box";
import { STYLES } from "./ShoppingCartStyles";

export const EmptyCart: React.FC = () => (
  <Box sx={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    height: '100px'
  }}>
    <Box
      sx={{
        border: `1px solid ${STYLES.colors.accent}`,
        color: STYLES.colors.accent,
        fontFamily: STYLES.fontFamily,
        fontSize: '14px',
        textAlign: 'center',
        padding: '6px',
        borderRadius: '0',
        width: '100%',
      }}
    >
      El carrito de compras está vacío.
    </Box>
  </Box>
);














